import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { restrictedLogin, setRestrictedToken } from "@/lib/api";
import { toast } from "sonner";

const CRIMSON = "#C8102E";

export default function RestrictedLogin() {
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await restrictedLogin(identifier.trim(), password);
            if (r.token) {
                setRestrictedToken(r.token);
                toast.success(`Welcome back, ${r.user.username}`);
                navigate("/restricted/shop");
            }
        } catch (err) {
            const detail = err?.response?.data?.detail;
            toast.error(typeof detail === "string" ? detail : "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] bg-ink-base flex items-center justify-center px-6 py-16" data-testid="restricted-login-page">
            <form onSubmit={submit} className="w-full max-w-md border-t-4 bg-ink-surface p-10" style={{ borderTopColor: CRIMSON }} data-testid="restricted-login-form">
                <Lock className="w-6 h-6" style={{ color: CRIMSON }} strokeWidth={1.5} />
                <h1 className="mt-4 font-display text-3xl font-bold text-ink">Restricted Catalog</h1>
                <p className="mt-2 text-sm text-ink-dim">Approved researchers only. Use the credentials emailed to you on approval.</p>

                <label className="block mt-6">
                    <span className="overline text-[10px] tracking-[0.2em] mb-2 block" style={{ color: CRIMSON }}>USERNAME OR EMAIL</span>
                    <input type="text" autoFocus required value={identifier} onChange={(e) => setIdentifier(e.target.value)}
                        className="w-full bg-ink-base text-ink px-4 py-3 text-sm outline-none border border-[#3a1418] focus:border-[#C8102E] transition-colors"
                        data-testid="restricted-login-identifier" />
                </label>

                <label className="block mt-4">
                    <span className="overline text-[10px] tracking-[0.2em] mb-2 block" style={{ color: CRIMSON }}>PASSWORD</span>
                    <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                        className="w-full bg-ink-base text-ink px-4 py-3 text-sm outline-none border border-[#3a1418] focus:border-[#C8102E] transition-colors"
                        data-testid="restricted-login-password" />
                </label>

                <button type="submit" disabled={loading}
                    className="w-full mt-6 inline-flex items-center justify-center gap-2 px-6 py-3 font-bold tracking-wider text-sm uppercase disabled:opacity-50 transition-colors"
                    style={{ background: CRIMSON, color: "#fff" }}
                    data-testid="restricted-login-submit">
                    {loading ? "SIGNING IN…" : "SIGN IN"} {!loading && <ArrowRight className="w-4 h-4" />}
                </button>

                <div className="mt-8 pt-6 border-t border-[#2a1418] text-xs text-ink-dim text-center">
                    Need access? <Link to="/restricted" className="hover:underline" style={{ color: CRIMSON }} data-testid="restricted-login-request-link">Request approval →</Link>
                </div>

                <p className="mt-8 text-[10px] font-mono uppercase tracking-[0.15em] leading-relaxed text-center" style={{ color: `${CRIMSON}aa` }}>
                    For laboratory & in-vitro research purposes only.
                </p>
            </form>
        </div>
    );
}
